import { atomFamily } from "recoil";

import { RydeUiUnit } from "../../models";

export const bulkSelectedControlsAtomFamily = atomFamily<string[], RydeUiUnit>({
  key: "bulkSelectedControlsAtomFamily",
  default: [],
});
